import * as ambassadorWixPaymentsDisputesV1Dispute from './payments-disputes-v1-dispute-disputes.http.js';
import * as ambassadorWixPaymentsDisputesV1DisputeTypes from './payments-disputes-v1-dispute-disputes.types.js';
import * as ambassadorWixPaymentsDisputesV1DisputeUniversalTypes from './payments-disputes-v1-dispute-disputes.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getDispute(): __PublicMethodMetaInfo<
  'GET',
  { disputeId: string },
  ambassadorWixPaymentsDisputesV1DisputeUniversalTypes.GetDisputeRequest,
  ambassadorWixPaymentsDisputesV1DisputeTypes.GetDisputeRequest,
  ambassadorWixPaymentsDisputesV1DisputeUniversalTypes.GetDisputeResponse,
  ambassadorWixPaymentsDisputesV1DisputeTypes.GetDisputeResponse
> {
  const payload = { disputeId: ':disputeId' } as any;

  const getRequestOptions =
    ambassadorWixPaymentsDisputesV1Dispute.getDispute(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/disputes/{disputeId}',
    pathParams: { disputeId: 'disputeId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryDisputes(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixPaymentsDisputesV1DisputeUniversalTypes.QueryDisputesRequest,
  ambassadorWixPaymentsDisputesV1DisputeTypes.QueryDisputesRequest,
  ambassadorWixPaymentsDisputesV1DisputeUniversalTypes.QueryDisputesResponse,
  ambassadorWixPaymentsDisputesV1DisputeTypes.QueryDisputesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPaymentsDisputesV1Dispute.queryDisputes(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/disputes/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function acceptDispute(): __PublicMethodMetaInfo<
  'POST',
  { disputeId: string },
  ambassadorWixPaymentsDisputesV1DisputeUniversalTypes.AcceptDisputeRequest,
  ambassadorWixPaymentsDisputesV1DisputeTypes.AcceptDisputeRequest,
  ambassadorWixPaymentsDisputesV1DisputeUniversalTypes.AcceptDisputeResponse,
  ambassadorWixPaymentsDisputesV1DisputeTypes.AcceptDisputeResponse
> {
  const payload = { disputeId: ':disputeId' } as any;

  const getRequestOptions =
    ambassadorWixPaymentsDisputesV1Dispute.acceptDispute(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/disputes/{disputeId}/accept',
    pathParams: { disputeId: 'disputeId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function defendDispute(): __PublicMethodMetaInfo<
  'POST',
  { disputeId: string },
  ambassadorWixPaymentsDisputesV1DisputeUniversalTypes.DefendDisputeRequest,
  ambassadorWixPaymentsDisputesV1DisputeTypes.DefendDisputeRequest,
  ambassadorWixPaymentsDisputesV1DisputeUniversalTypes.DefendDisputeResponse,
  ambassadorWixPaymentsDisputesV1DisputeTypes.DefendDisputeResponse
> {
  const payload = { disputeId: ':disputeId' } as any;

  const getRequestOptions =
    ambassadorWixPaymentsDisputesV1Dispute.defendDispute(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/disputes/{disputeId}/defend',
    pathParams: { disputeId: 'disputeId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateDisputeTags(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPaymentsDisputesV1DisputeUniversalTypes.BulkUpdateDisputeTagsRequest,
  ambassadorWixPaymentsDisputesV1DisputeTypes.BulkUpdateDisputeTagsRequest,
  ambassadorWixPaymentsDisputesV1DisputeUniversalTypes.BulkUpdateDisputeTagsResponse,
  ambassadorWixPaymentsDisputesV1DisputeTypes.BulkUpdateDisputeTagsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPaymentsDisputesV1Dispute.bulkUpdateDisputeTags(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/disputes/update-tags',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateDisputeTagsByFilter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPaymentsDisputesV1DisputeUniversalTypes.BulkUpdateDisputeTagsByFilterRequest,
  ambassadorWixPaymentsDisputesV1DisputeTypes.BulkUpdateDisputeTagsByFilterRequest,
  ambassadorWixPaymentsDisputesV1DisputeUniversalTypes.BulkUpdateDisputeTagsByFilterResponse,
  ambassadorWixPaymentsDisputesV1DisputeTypes.BulkUpdateDisputeTagsByFilterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPaymentsDisputesV1Dispute.bulkUpdateDisputeTagsByFilter(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/disputes/update-tags-by-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Dispute as DisputeOriginal,
  DisputeStage as DisputeStageOriginal,
  DisputeStageWithLiterals as DisputeStageWithLiteralsOriginal,
  DisputeReason as DisputeReasonOriginal,
  DisputeReasonWithLiterals as DisputeReasonWithLiteralsOriginal,
  DisputeStatus as DisputeStatusOriginal,
  DisputeStatusWithLiterals as DisputeStatusWithLiteralsOriginal,
  SellerProtection as SellerProtectionOriginal,
  SellerProtectionWithLiterals as SellerProtectionWithLiteralsOriginal,
  DisputeChannel as DisputeChannelOriginal,
  DisputeChannelWithLiterals as DisputeChannelWithLiteralsOriginal,
  DisputeAction as DisputeActionOriginal,
  DisputeActionType as DisputeActionTypeOriginal,
  DisputeActionTypeWithLiterals as DisputeActionTypeWithLiteralsOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  Tags as TagsOriginal,
  TagList as TagListOriginal,
  TagsModified as TagsModifiedOriginal,
  GetDisputeRequest as GetDisputeRequestOriginal,
  GetDisputeResponse as GetDisputeResponseOriginal,
  QueryDisputesRequest as QueryDisputesRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryDisputesResponse as QueryDisputesResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  AcceptDisputeRequest as AcceptDisputeRequestOriginal,
  AcceptDisputeResponse as AcceptDisputeResponseOriginal,
  DefendDisputeRequest as DefendDisputeRequestOriginal,
  DefendDisputeResponse as DefendDisputeResponseOriginal,
  BulkUpdateDisputeTagsRequest as BulkUpdateDisputeTagsRequestOriginal,
  BulkUpdateDisputeTagsResponse as BulkUpdateDisputeTagsResponseOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkUpdateDisputeTagsResult as BulkUpdateDisputeTagsResultOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  BulkUpdateDisputeTagsByFilterRequest as BulkUpdateDisputeTagsByFilterRequestOriginal,
  BulkUpdateDisputeTagsByFilterResponse as BulkUpdateDisputeTagsByFilterResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  BulkUpdateDisputeTagsApplicationErrors as BulkUpdateDisputeTagsApplicationErrorsOriginal,
  BulkUpdateDisputeTagsByFilterApplicationErrors as BulkUpdateDisputeTagsByFilterApplicationErrorsOriginal,
} from './payments-disputes-v1-dispute-disputes.types.js';
